/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_BildungsgradInputs */

const en__field_bildungsgrad = /** @type {(inputs: _Field_BildungsgradInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Educational Degree`)
};

const de__field_bildungsgrad = /** @type {(inputs: _Field_BildungsgradInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildungsgrad`)
};

/**
* | output |
* | --- |
* | "Educational Degree" |
*
* @param {_Field_BildungsgradInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_bildungsgrad = /** @type {((inputs?: _Field_BildungsgradInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_BildungsgradInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_bildungsgrad(inputs)
	return de__field_bildungsgrad(inputs)
});